export const comments_3787344 = {"data":{"data":[],"links":{}}}